import { render, staticRenderFns } from "./post_management.vue?vue&type=template&id=48fe348e"
import script from "./post_management.vue?vue&type=script&lang=js"
export * from "./post_management.vue?vue&type=script&lang=js"
import style0 from "./post_management.vue?vue&type=style&index=0&id=48fe348e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports